import { Html } from '../_models/html';

export function htmlToText(html: Html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.innerText
}